/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import { action, computed } from '@ember/object';
import DS from 'ember-data';
import ApiService from 'cio/services/api';
import ApiErrorsService from 'cio/services/api-errors';

interface EditorArgs {
  actionAbstract: Record<string, any>;
  isSaving?: boolean;
  onDeselect: () => unknown;
  onSelect: () => unknown;
  hasReadOnlyPermission: boolean;
}

export default class Editor extends Component<EditorArgs> {
  @service api!: ApiService;
  @service apiErrors!: ApiErrorsService;
  @service store!: DS.Store;

  @tracked segments: Record<string, any>[] = [];

  @computed('args.actionAbstract.segmentId', 'segments.[]')
  get selectedItem() {
    let { segmentId } = this.args.actionAbstract;

    if (segmentId == null) {
      return null;
    }

    let segment = this.segments.find((s) => s.value === segmentId);

    if (segment == null) {
      return null;
    }

    return {
      name: segment.name,
      value: segment.id,
    };
  }

  @action
  fetchSegments() {
    let segments = this.store
      .peekAll('short-segment')
      .filterBy('isManual', true)
      .map((segment) => ({
        name: segment.name,
        value: segment.id,
      }));

    this.segments = segments;
  }

  @action
  async onSegmentChange(item: { name: string; value: string }) {
    this.args.actionAbstract.set('segmentId', item.value);
  }
}
